export default "__VITE_ASSET__CCYdGn5a__"